import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=1651b559&lang=pug&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=1651b559&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1651b559')) {
      api.createRecord('1651b559', component.options)
    } else {
      api.reload('1651b559', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=1651b559&lang=pug&", function () {
      api.rerender('1651b559', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/interface/Loader.vue"
export default component.exports